import { __rest } from "tslib";
import React from 'react';
import { string } from 'prop-types';
import clsx from 'clsx';
import { Spinner } from '../Spinner';
import './PageLoader.less';
export default function PageLoader(props) {
    const { className } = props, otherProps = __rest(props, ["className"]);
    return (React.createElement("div", Object.assign({ className: clsx(className, 'kal-page-loader') }, otherProps),
        React.createElement(Spinner, { changeHue: true })));
}
PageLoader.propTypes = {
    /** CSS class to be applied to the root element */
    className: string,
};
//# sourceMappingURL=PageLoader.js.map